<template>
    <section class="online-scheduling-catanduva">
        <div class="site-container site-section-v">
            <div style="width:70%;margin: 0 auto;">
                <h2 class="text-orange" style="margin-bottom: 3rem">
                    Atendimento Online
                </h2>
                <p>
                    Fale agora com um advogado ou agende um atendimento
                    telepresencial com um de nossos advogados de forma rápida e
                    escolhendo você mesmo o melhor horário para falar conosco.
                    Insira suas informações, selecione o dia e horário do
                    atendimento, receba o link para acesso à reunião virtual e é
                    só aguardar.
                </p>
                <p>
                    Selecione a opção desejada:
                </p>
                <div style="margin-top: 20px;">
                    <button
                        type="submit"
                        class="button button-orange"
                        style="padding: 20px;"
                        v-on:click="onlineScheduling = false"
                    >
                        Falar com um advogado agora
                    </button>
                    <button
                        type="submit"
                        class="button button-orange"
                        style="float: right; padding: 20px;"
                        v-on:click="onlineScheduling = true"
                    >
                        Agendar atendimento virtual
                    </button>
                </div>
            </div>

            <div
                id="section-form"
                v-if="onlineScheduling == true"
                style="margin-top:30px;"
            >
                <form-scheduling origem='CATANDUVA'>
                    <template #form-top>
                        <p>
                           Preencha os campos abaixo para agendar o seu atendimento virtual.
                        </p>
                        
                    </template>
                </form-scheduling>
            </div>

            <div id="section-iframe" v-if="onlineScheduling == false">
                <iframe
                    id="iframe-catanduva"
                    width="800"
                    height="800"
                    scrolling="no"
                    frameBorder="0"
                    style="margin-left:15%;"
                    src="https://crivelliadvogados.sz.chat/webchat/v2/?cid=64259f72b55c30001aa50463&amp;host=https%3A%2F%2Fcrivelliadvogados.sz.chat&amp;locale=pt-BR"
                    allow="microphone"
                ></iframe>
            </div>

            <hr />
            <download-app />
        </div>
    </section>
</template>

<script>
import FormScheduling from "@/components/FormScheduling";
import DownloadApp from "@/components/Home/DownloadApp";

export default {
    components: { DownloadApp, FormScheduling },

    data() {
        return {
            onlineScheduling: null
        };
    }
};
</script>

<style></style>
